import Script from "next/script";
import * as snippet from '@segment/snippet';
import getConfig from "next/config";
const { publicRuntimeConfig } = getConfig();

// const DEFAULT_WRITE_KEY = 'pEtj3wqVqhaZ06hda3RcxPcl7HTpD5EZ'
const WRITE_KEY = publicRuntimeConfig.ANALYTICS_WRITE_KEY
function renderSnippet() {
  const opts = {
    apiKey: WRITE_KEY,
    // note: the page option only covers SSR tracking.
    // Page.js is used to track other events using `window.analytics.page()`
    page: false,
  }

  if (process.env.NODE_ENV === 'development') {
    return snippet.max(opts)
  }

  return snippet.max(opts)
}

export default function Segment() {
  return (
    <>
      {WRITE_KEY && <Script
        strategy="afterInteractive"
        id="segment-script"
        dangerouslySetInnerHTML={{ __html: renderSnippet() }}
      />}
    </>
  );
}
